import React, {useRef} from "react"
import {formatTextTestIds} from "@next/utils"
import connect from "./connect"
import {FacetsGridContainer, FacetsGridList, FacetsGridListItem} from "./components"
import {FacetState} from "../../models/FacetsState"
import Filter from "../facet"

export interface FacetsGridProps {
    facets: FacetState[]
    handleSetFacet: (facetValue: string) => void
}

export const FacetsGrid = ({facets, handleSetFacet}: FacetsGridProps) => {
    const filtersGridContainerElement = useRef<HTMLDivElement>(null)
    return (
        <FacetsGridContainer
            data-testid={formatTextTestIds("filter-grid-container")}
            ref={filtersGridContainerElement}
            variant="outlined"
            square
        >
            <FacetsGridList>
                {facets.map(filter => (
                    <FacetsGridListItem key={filter.v}>
                        <Filter facet={filter} handleSetFacet={handleSetFacet} modal />
                    </FacetsGridListItem>
                ))}
            </FacetsGridList>
        </FacetsGridContainer>
    )
}

export default connect(FacetsGrid)
